import { queryClient } from "~/backend/queryClient"
import { useDeleteOperationChain, findOperationChainsQueryKey } from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useDeleteOpChainMutation = () =>
  useDeleteOperationChain({
    mutation: {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: findOperationChainsQueryKey(),
        })
        showSuccessNotification({
          title: "Success",
          message: "Operation chain deleted",
        })
      },
      onError: (error) => {
        showAxiosError({
          notificationTitle: "Error",
          notificationMessage: "Failed to delete operation chain",
          showNotification: true,
          error,
        })
      },
    },
  })
